import React, { useEffect } from "react";
import { Icons } from "assets/icons";
import FilterBar from "components/common/FilterBar";
import TableShimmer from "components/common/TableShimmer";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// Replace with vehicle configs
import {
  getAddons,
  resetAddonFilters,
  setAddonFilter
} from "store/slices/membershipSlice";
import { getActionFlags } from "utils/getActionFlags";
import { getMinMaxDate } from "utils/utils";
import { ORDER_BY_OPTIONS, STATUS_OPTIONS } from "utils/constants";

const Vehicles = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    loading,
    addonFilters: { perPage, pageNo, status, orderBy, keyword, dates },
  } = useSelector((state) => state.Membership);
  useEffect(() => {
    getAllData();
  }, []);

  const getAllData = (page, action) => {
    const { isReset, isResetKeyword } = getActionFlags(action);

    const payload = {
      perPage,
      pageNo: page || pageNo,
      status: isReset ? -1 : status,
      orderBy: isReset ? -1 : orderBy,
      keyword: isResetKeyword ? "" : keyword || "",
      dateRange: isReset ? {} : getMinMaxDate(dates),
    };

    dispatch(getAddons(payload));
  };

  const handleReset = () => {
    dispatch(resetAddonFilters());
    getAllData(1, { actionType: "RESET" });
  };

  const filtersList = [
    {
      key: "status",
      placeholder: t("Status"),
      type: "singleSelect",
      options: STATUS_OPTIONS,
    },
    {
      key: "orderBy",
      placeholder: t("Order By"),
      type: "singleSelect",
      options: ORDER_BY_OPTIONS,
    },
  ];

  return (
    <div className="page-content vehicles">
      {" "}
      <h4 className="mb-4 page_title">{t("Vehicles")}</h4>
      <FilterBar
        keyword={keyword}
        setKeyword={(value) =>
          dispatch(setAddonFilter({ key: "keyword", value }))
        }
        filters={filtersList}
        selectedFilters={{ keyword, status, orderBy }}
        onFilterUpdate={(key, value) =>
          dispatch(setAddonFilter({ key, value }))
        }
        dates={dates}
        setDates={(value) => dispatch(setAddonFilter({ key: "dates", value }))}
        onSearch={getAllData}
        onReset={handleReset}
        isBtn={true}
        btnText={t("Add Vehicle")}
        onBtnClick={() => navigate("/vehicles/add-vehicle")}
      />
      {loading && <TableShimmer rows={12} columns={8} />}
    </div>
  );
};

export default Vehicles;
